import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouterLegacy } from 'core/routerUtils';
import { withTranslation } from 'react-i18next';
import * as dashboardActions from 'features/dashboard/duck';
import * as userActions from 'core/duck';
import * as tcRenewalAction from 'features/tc-renewal/duck';
import TCRenewalGuide from '../tc-renewal-guide/TCRenewalGuide';
import {
  TCRenewalSteps,
  CoordinatorAgreement,
  TCAlternateContacts,
  TCReportingLocations,
  TCSecureStorageContainer,
  TCSecurityInformation,
  TCMessageTestDates,
  TCDigitalAssessment,
  TCTestDates,
} from 'features/tc-renewal/';

import './TCRenewalContainer.scss';

class TCRenewalContainer extends Component {
  constructor(props) {
    super(props);
    this.child = React.createRef();
    this.steps = [
      {
        id: 0,
        name: 'coordinator-agreement',
        component: CoordinatorAgreement,
      },
      {
        id: 1,
        name: 'renewal-guide',
        component: TCRenewalGuide,
      },
      {
        id: 2,
        name: 'alternate-contacts',
        component: TCAlternateContacts,
      },
      {
        id: 3,
        name: 'secure-storage',
        component: TCSecureStorageContainer,
      },
      {
        id: 4,
        name: 'security-information',
        component: TCSecurityInformation,
      },
      {
        id: 5,
        name: 'reporting-locations',
        component: TCReportingLocations,
      },
      {
        id: 6,
        name: 'review-test-dates',
        component: TCTestDates,
      },
      {
        id: 7,
        name: 'message-test-dates',
        component: TCMessageTestDates,
      },
      {
        id: 8,
        name: 'digital-assessment',
        component: TCDigitalAssessment,
      },
    ];

    this.saveAndExit = this.saveAndExit.bind(this);
  }

  componentDidMount() {
    const { match } = this.props;

    this.props.actions.getTcCycle(match.params.tcCycleId);
  }

  saveAndExit() {
    const { testCenterCycle } = this.props;

    this.child.current.handleRedirect(null, `/test-center/${testCenterCycle.id}`);
  }

  render() {
    const { match, location } = this.props;
    // Extract action from pathname: test-center-renewal or test-center-establishment
    const action = location.pathname.split('/')[1].split('-').at(-1);

    return (
      <div className="renewal-container">
        {match.params.step !== 'successfully-submitted' && (
          <div className="renewal-header">
            <div>
              {action === 'renewal' ? (
                <span>{this.props.t('testCenter.renewalSectionTitle')}</span>
              ) : (
                <span>{this.props.t('testCenter.establishSectionTitle')}</span>
              )}
              <span className="btn-save" onClick={this.saveAndExit}>
                {this.props.t('testCenter.renewalExit')}
              </span>
            </div>
          </div>
        )}
        <div className="renewal-content">
          <TCRenewalSteps
            ref={this.child}
            steps={this.steps}
            TCUrlAction={action}
            {...this.props}
          />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    users: state.users || {},
    currentUser: state.users.currentUser,
    testCenterCycle: state.tcRenewal.tcCycle,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...dashboardActions,
        ...userActions,
        ...tcRenewalAction,
      },
      dispatch
    ),
  };
}

export default withTranslation()(
  withRouterLegacy(connect(mapStateToProps, mapDispatchToProps)(TCRenewalContainer))
);

TCRenewalContainer.propTypes = {
  // Props from react-router (via withRouterLegacy)
  match: PropTypes.shape({
    params: PropTypes.shape({
      tcCycleId: PropTypes.string.isRequired,
      step: PropTypes.string,
    }).isRequired,
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,

  // Props from mapStateToProps
  users: PropTypes.object,
  currentUser: PropTypes.object,
  testCenterCycle: PropTypes.shape({
    id: PropTypes.number,
  }),

  // Props from mapDispatchToProps
  actions: PropTypes.shape({
    getTcCycle: PropTypes.func.isRequired,
  }).isRequired,
  t: PropTypes.func.isRequired,
};
